/**
 * An enum used when logic needs to be differentiated based on which app is
 * using a module. In apps, this is set once and left alone. In storybook, this
 * defaults to `pro`, if the user is logged out. Otherwise, the role of the
 * user is used to determine which logic should be used.
 *
 * Although we can check user role to differentiate logic, this functionality
 * remains in case we need to differentiate logic for logged out users.
 */
var ConsumingApp;
(function (ConsumingApp) {
    ConsumingApp["DASHBOARD"] = "dashboard";
    ConsumingApp["PATIENT"] = "patient";
    ConsumingApp["PRO"] = "pro";
})(ConsumingApp || (ConsumingApp = {}));
var BrandTheme;
(function (BrandTheme) {
    BrandTheme["CARESEND"] = "caresend";
    BrandTheme["EXACT"] = "exact";
})(BrandTheme || (BrandTheme = {}));
var LoadingReason;
(function (LoadingReason) {
    LoadingReason["AUTH"] = "Authenticating\u2026";
    LoadingReason["CUSTOM"] = "custom";
    LoadingReason["ROUTE"] = "Loading page\u2026";
    LoadingReason["VARIABLES"] = "Loading app\u2026";
})(LoadingReason || (LoadingReason = {}));
const globalLoadingStates = [
    {
        blocking: true,
        getIsLoading: ({ rootState }) => !rootState.variables.variables,
        reason: LoadingReason.VARIABLES,
    },
    {
        getIsLoading: ({ rootState }) => rootState.auth.authLoading,
        reason: LoadingReason.AUTH,
    },
    {
        getIsLoading: ({ state }) => state.showRouteLoading,
        getCustomLoadingMessage: ({ route }) => { var _a, _b; return (_b = (_a = route === null || route === void 0 ? void 0 : route.meta) === null || _a === void 0 ? void 0 : _a.loadingMessage) === null || _b === void 0 ? void 0 : _b.call(_a, route); },
        reason: LoadingReason.ROUTE,
    },
];

export { BrandTheme, ConsumingApp, LoadingReason, globalLoadingStates };
